// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fT2YL","controls":"styles_controls__21e3s","charLimit":"styles_charLimit__KVO5W","input":"styles_input__2rnLY","send":"styles_send__D3L4s"};